module.exports = __webpack_public_path__ + "static/media/nottingham_bs.856fcd38.jfif";